<div class="aur-mat-table"
     [ngClass]="{'sticky-pagination': paginationProvider.isEnabled && !externalPaginator && paginationProvider.position === 'sticky'}">
  <ng-container>
    <!-- Filter -->
    <ng-container *ngIf="isFeatureEnabled(tableConfig.filterCfg)">
      <div class="search-container">
        <ng-container>
          <ng-content select="[ngxAurTableSearchPrefix]"></ng-content>
        </ng-container>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ tableConfig.filterCfg?.label }}</mat-label>
          <input matInput (keyup)="applySearchFilter($event)"
                 placeholder="{{tableConfig.filterCfg?.placeholder}}"
                 style="font-size: 18px;">
          <mat-icon matPrefix>search</mat-icon>
        </mat-form-field>
        <ng-container>
          <ng-content select="[ngxAurTableSearchSuffix]"></ng-content>
        </ng-container>
      </div>
    </ng-container>


    <div class="table-container"
         [ngClass]="{'sticky-pagination': paginationProvider.isEnabled && !externalPaginator && paginationProvider.position === 'sticky'}">
      <mat-icon *ngIf="headerButtonProvider.isEnabled"
                class="table-settings-button"
                [style.color]="headerButtonProvider.color"
                [style.background-color]="headerButtonProvider.background"
                (click)="headerButton.emit($event)">
        {{ headerButtonProvider.icon }}
      </mat-icon>

      <!-- Table -->
      <table #table mat-table matSort
             [matSortActive]="tableConfig.sortCfg?.active ?? ''"
             [matSortDirection]="tableConfig.sortCfg?.direction ?? ''"
             [trackBy]="trackByRow"
             [multiTemplateDataRows]="expandedRowTemplate !== null"
             [dataSource]="tableDataSource"
             (matSortChange)="sortTable($event)"
             [style.height]="tableConfig.tableViewCfg?.height"
             [style.max-height]="tableConfig.tableViewCfg?.maxHeight"
             [style.min-height]="tableConfig.tableViewCfg?.minHeight"
             [class.aur-has-header-button]="headerButtonProvider.isEnabled"
             [style.--aur-cell-padding-left]="tableConfig.tableViewCfg?.cellPaddingLeft"
             [style.--aur-cell-padding-right]="tableConfig.tableViewCfg?.cellPaddingRight"
             [ngClass]="{'hide-table-body': isTableBodyHide}">


        <!--        timeline-column-->
        <ng-container *ngIf="timelineProvider.isEnabled" [matColumnDef]="timelineProvider.COLUMN_NAME">
          <th mat-header-cell *matHeaderCellDef class="aur-timeline-cell"
              [style.width]="timelineProvider.size?.width"
              [style.min-width]="timelineProvider.size?.minWidth"
              [style.max-width]="timelineProvider.size?.maxWidth"
              [class.aur-col-fit]="timelineProvider.size?.fit"
              [style.--aur-cell-padding-left]="timelineProvider.size?.paddingLeft"
              [style.--aur-cell-padding-right]="timelineProvider.size?.paddingRight"></th>
          <td mat-cell *matCellDef="let element" class="aur-timeline-cell"
              [style.width]="timelineProvider.size?.width"
              [style.min-width]="timelineProvider.size?.minWidth"
              [style.max-width]="timelineProvider.size?.maxWidth"
              [class.aur-col-fit]="timelineProvider.size?.fit"
              [style.--aur-cell-padding-left]="timelineProvider.size?.paddingLeft"
              [style.--aur-cell-padding-right]="timelineProvider.size?.paddingRight">
            <div class="aur-timeline-marker-container">

              <div class="aur-timeline-line"
                   *ngIf="element.rowId !== _timelineFirstId"
                   [style.border-left-width.px]="timelineProvider.line.width"
                   [style.border-left-color]="_timelineGaps.get(element.rowId)?.topColor ?? timelineProvider.line.color"
                   [style.border-left-style]="_timelineGaps.get(element.rowId)?.topGap ? timelineProvider.line.gapStyle : timelineProvider.line.style">
              </div>

              <ng-container *ngIf="rowMarkerTemplate; else defaultMarker">
                <ng-container *ngTemplateOutlet="rowMarkerTemplate; context: rowCtx(element)"></ng-container>
              </ng-container>
              <ng-template #defaultMarker>
                <div class="aur-timeline-marker-default"
                     [style.background-color]="timelineProvider.markerColor">
                </div>
              </ng-template>

              <div class="aur-timeline-line"
                   *ngIf="element.rowId !== _timelineLastId"
                   [style.border-left-width.px]="timelineProvider.line.width"
                   [style.border-left-color]="_timelineGaps.get(element.rowId)?.bottomColor ?? timelineProvider.line.color"
                   [style.border-left-style]="_timelineGaps.get(element.rowId)?.bottomGap ? timelineProvider.line.gapStyle : timelineProvider.line.style">
              </div>

            </div>
          </td>
          <td mat-footer-cell *matFooterCellDef class="aur-timeline-cell"
              [style.width]="timelineProvider.size?.width"
              [style.min-width]="timelineProvider.size?.minWidth"
              [style.max-width]="timelineProvider.size?.maxWidth"
              [class.aur-col-fit]="timelineProvider.size?.fit"
              [style.--aur-cell-padding-left]="timelineProvider.size?.paddingLeft"
              [style.--aur-cell-padding-right]="timelineProvider.size?.paddingRight"></td>
        </ng-container>

        <!--        drag-column-->
        <ng-container *ngIf="dragDropProvider.isEnabled && dragDropProvider.draggable" [matColumnDef]="dragDropProvider.COLUMN_NAME">

          <th mat-header-cell *matHeaderCellDef
              [style.width]="dragDropProvider.size?.width"
              [style.min-width]="dragDropProvider.size?.minWidth"
              [style.max-width]="dragDropProvider.size?.maxWidth"
              [class.aur-col-fit]="dragDropProvider.size?.fit"
              [style.--aur-cell-padding-left]="dragDropProvider.size?.paddingLeft"
              [style.--aur-cell-padding-right]="dragDropProvider.size?.paddingRight">
          </th>

          <td mat-cell *matCellDef="let element;" class="drag-column"
              [style.width]="dragDropProvider.size?.width"
              [style.min-width]="dragDropProvider.size?.minWidth"
              [style.max-width]="dragDropProvider.size?.maxWidth"
              [class.aur-col-fit]="dragDropProvider.size?.fit"
              [style.--aur-cell-padding-left]="dragDropProvider.size?.paddingLeft"
              [style.--aur-cell-padding-right]="dragDropProvider.size?.paddingRight">
            <lib-icon-view  draggable="true"
                            class="drag-icon"
                            [view]="dragDropProvider.dragIconView"
                            (dragstart)="onDragStart($event, element)"
                            (dragend)="onDragEnd($event, element)">
            </lib-icon-view>

          </td>

          <td mat-footer-cell *matFooterCellDef
              [style.width]="dragDropProvider.size?.width"
              [style.min-width]="dragDropProvider.size?.minWidth"
              [style.max-width]="dragDropProvider.size?.maxWidth"
              [class.aur-col-fit]="dragDropProvider.size?.fit"
              [style.--aur-cell-padding-left]="dragDropProvider.size?.paddingLeft"
              [style.--aur-cell-padding-right]="dragDropProvider.size?.paddingRight">
          </td>
        </ng-container>

        <!--        index-column-->
        <ng-container *ngIf="indexProvider.isEnabled" [matColumnDef]="indexProvider.COLUMN_NAME">

          <th mat-header-cell *matHeaderCellDef
              [style.width]="indexProvider.size?.width"
              [style.min-width]="indexProvider.size?.minWidth"
              [style.max-width]="indexProvider.size?.maxWidth"
              [class.aur-col-fit]="indexProvider.size?.fit"
              [style.--aur-cell-padding-left]="indexProvider.size?.paddingLeft"
              [style.--aur-cell-padding-right]="indexProvider.size?.paddingRight"
              [ngClass]="_alignClass[indexProvider.COLUMN_NAME]">
            <!-- имя передаётся через [value]: у lib-column-view нет ng-content, проекция гасится -->
            <lib-column-view [config]="indexProvider.headerView" [value]="indexProvider.name">
            </lib-column-view>
          </th>

          <td mat-cell *matCellDef="let element;"
              [style.width]="indexProvider.size?.width"
              [style.min-width]="indexProvider.size?.minWidth"
              [style.max-width]="indexProvider.size?.maxWidth"
              [class.aur-col-fit]="indexProvider.size?.fit"
              [style.--aur-cell-padding-left]="indexProvider.size?.paddingLeft"
              [style.--aur-cell-padding-right]="indexProvider.size?.paddingRight"
              [ngClass]="_alignClass[indexProvider.COLUMN_NAME]">
            {{ indexProvider.format(element.rowId + _indexPageOffset) }}
          </td>

          <td mat-footer-cell *matFooterCellDef
              [style.width]="indexProvider.size?.width"
              [style.min-width]="indexProvider.size?.minWidth"
              [style.max-width]="indexProvider.size?.maxWidth"
              [class.aur-col-fit]="indexProvider.size?.fit"
              [style.--aur-cell-padding-left]="indexProvider.size?.paddingLeft"
              [style.--aur-cell-padding-right]="indexProvider.size?.paddingRight"
              [ngClass]="_alignClass[indexProvider.COLUMN_NAME]">
            {{ totalRowProvider.totals.get(indexProvider.COLUMN_NAME) ?? '' }}
          </td>
        </ng-container>

        <!--        selection-column-->
        <ng-container [matColumnDef]="selectionProvider.COLUMN_NAME" *ngIf="selectionProvider.isEnabled">
          <th mat-header-cell *matHeaderCellDef
              [style.width]="selectionProvider.size?.width"
              [style.min-width]="selectionProvider.size?.minWidth"
              [style.max-width]="selectionProvider.size?.maxWidth"
              [class.aur-col-fit]="selectionProvider.size?.fit"
              [style.--aur-cell-padding-left]="selectionProvider.size?.paddingLeft"
              [style.--aur-cell-padding-right]="selectionProvider.size?.paddingRight">
            <div class="flex-container">
              <mat-checkbox (change)="$event ? masterToggle() : null"
                            [checked]="selectionProvider.selection.hasValue() && isAllSelected()"
                            [indeterminate]="selectionProvider.selection.hasValue() && !isAllSelected()">
              </mat-checkbox>
              <div
                *ngIf="tableConfig.selectionCfg?.showSelectedCount && selectionProvider.selection.hasValue()">
                {{ selectionProvider.selection.selected.length }}
                <span
                  *ngIf="tableConfig.selectionCfg?.showTotalCount !== false">/{{ paginatorState?.length ? paginatorState?.length : tableDataSource.filteredData.length }}</span>
              </div>

              <div *ngIf="selectionProvider.selection.hasValue() && tableConfig?.selectionCfg?.actions">
                <ng-container *ngFor="let action of tableConfig.selectionCfg!.actions">
                  <button mat-icon-button
                          (click)="emitSelectedRowsAction(action.action, selectionProvider.selection.selected)"
                          [matTooltip]="action.icon.tooltip || ''"
                          [matTooltipPosition]="action.icon.tooltipPosition || 'below'"
                          *ngIf="action.visible !== false">
                    <mat-icon [style.color]="action.icon.color">
                      {{ action.icon.name }}
                    </mat-icon>
                  </button>
                </ng-container>
              </div>
            </div>

          </th>
          <td mat-cell *matCellDef="let row"
              (click)="$event.stopPropagation(); selectionProvider.selection.toggle(castSrc(row).rowSrc)"
              [style.width]="selectionProvider.size?.width"
              [style.min-width]="selectionProvider.size?.minWidth"
              [style.max-width]="selectionProvider.size?.maxWidth"
              [class.aur-col-fit]="selectionProvider.size?.fit"
              [style.--aur-cell-padding-left]="selectionProvider.size?.paddingLeft"
              [style.--aur-cell-padding-right]="selectionProvider.size?.paddingRight">
            <mat-checkbox (click)="$event.stopPropagation()"
                          (change)="$event ? selectionProvider.selection.toggle(castSrc(row).rowSrc) : null"
                          [checked]="selectionProvider.selection.isSelected(castSrc(row).rowSrc)">
            </mat-checkbox>
          </td>

          <td mat-footer-cell *matFooterCellDef
              [style.width]="selectionProvider.size?.width"
              [style.min-width]="selectionProvider.size?.minWidth"
              [style.max-width]="selectionProvider.size?.maxWidth"
              [class.aur-col-fit]="selectionProvider.size?.fit"
              [style.--aur-cell-padding-left]="selectionProvider.size?.paddingLeft"
              [style.--aur-cell-padding-right]="selectionProvider.size?.paddingRight">
          </td>
        </ng-container>

        <!-- action columns (одна или несколько) -->
        <ng-container *ngFor="let col of rowActionsProvider.columns; trackBy: trackByActionColumn"
                      [matColumnDef]="col.columnName">
          <th mat-header-cell *matHeaderCellDef
              [style.width]="col.size?.width"
              [style.min-width]="col.size?.minWidth"
              [style.max-width]="col.size?.maxWidth"
              [class.aur-col-fit]="col.size?.fit"
              [style.--aur-cell-padding-left]="col.size?.paddingLeft"
              [style.--aur-cell-padding-right]="col.size?.paddingRight"></th>
          <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()" style="cursor: default"
              [style.width]="col.size?.width"
              [style.min-width]="col.size?.minWidth"
              [style.max-width]="col.size?.maxWidth"
              [class.aur-col-fit]="col.size?.fit"
              [style.--aur-cell-padding-left]="col.size?.paddingLeft"
              [style.--aur-cell-padding-right]="col.size?.paddingRight">
            <ng-container *ngFor="let action of col.actionView.get(element.rowId)">
              <!-- action with dropdown menu -->
              <ng-container *ngIf="action.menu; else directAction">
                <ng-container *ngIf="action.visible !== false">
                  <mat-menu #actionMenu="matMenu">
                    <ng-container *ngFor="let item of action.menu">
                      <button mat-menu-item
                              *ngIf="item.visible !== false"
                              [disabled]="item.disabled === true"
                              (click)="emitMenuAction(item.action, element.rowSrc)">
                        <mat-icon *ngIf="item.icon" [style.color]="iconColorOf(item)">
                          {{ item.icon.name }}
                        </mat-icon>
                        <span>{{ item.text }}</span>
                      </button>
                    </ng-container>
                  </mat-menu>
                  <span *ngIf="action.icon.tooltip; else menuBtnPlain"
                        [matTooltip]="action.icon.tooltip"
                        [matTooltipClass]="action.icon.tooltipClass || ''"
                        [matTooltipPosition]="action.icon.tooltipPosition || 'below'">
                    <button mat-icon-button
                            [matMenuTriggerFor]="actionMenu"
                            [disabled]="action.disabled === true">
                      <mat-icon [style.color]="iconColorOf(action)">
                        {{ action.icon.name }}
                      </mat-icon>
                    </button>
                  </span>
                  <ng-template #menuBtnPlain>
                    <button mat-icon-button [matMenuTriggerFor]="actionMenu"
                            [disabled]="action.disabled === true">
                      <mat-icon [style.color]="iconColorOf(action)">
                        {{ action.icon.name }}
                      </mat-icon>
                    </button>
                  </ng-template>
                </ng-container>
              </ng-container>

              <!-- direct action (existing behavior) -->
              <ng-template #directAction>
                <ng-container *ngIf="action.visible !== false">
                  <span *ngIf="action.icon.tooltip; else directBtnPlain"
                        [matTooltip]="action.icon.tooltip"
                        [matTooltipClass]="action.icon.tooltipClass || ''"
                        [matTooltipPosition]="action.icon.tooltipPosition || 'below'">
                    <button mat-icon-button
                            [disabled]="action.disabled === true"
                            (click)="emitRowAction(action.action, element.rowSrc, $event)">
                      <mat-icon [style.color]="iconColorOf(action)">
                        {{ action.icon.name }}
                      </mat-icon>
                    </button>
                  </span>
                  <ng-template #directBtnPlain>
                    <button mat-icon-button
                            [disabled]="action.disabled === true"
                            (click)="emitRowAction(action.action, element.rowSrc, $event)">
                      <mat-icon [style.color]="iconColorOf(action)">
                        {{ action.icon.name }}
                      </mat-icon>
                    </button>
                  </ng-template>
                </ng-container>
              </ng-template>
            </ng-container>
          </td>

          <td mat-footer-cell *matFooterCellDef
              [style.width]="col.size?.width"
              [style.min-width]="col.size?.minWidth"
              [style.max-width]="col.size?.maxWidth"
              [class.aur-col-fit]="col.size?.fit"
              [style.--aur-cell-padding-left]="col.size?.paddingLeft"
              [style.--aur-cell-padding-right]="col.size?.paddingRight">
            {{ totalRowProvider.totals.get(col.columnName) ?? '' }}
          </td>
        </ng-container>

        <!--    value-icon-->
        <ng-container *ngFor="let columnConfig of tableConfig.columnsCfg" [matColumnDef]="columnConfig.key">

          <!-- if sortable column header (и шаблон не забрал ячейку через ownsCell) -->
          <ng-container *ngIf="isHeaderSortHeader(columnConfig); else notSortable">
            <th mat-header-cell *matHeaderCellDef [mat-sort-header]="columnConfig.key"
                [arrowPosition]="columnConfig.sort?.position === 'start' ? 'before' : 'after'"
                [style.width]="columnConfig.size?.width"
                [style.min-width]="columnConfig.size?.minWidth"
                [style.max-width]="columnConfig.size?.maxWidth"
                [class.aur-col-fit]="columnConfig.size?.fit"
                [style.--aur-cell-padding-left]="columnConfig.size?.paddingLeft"
                [style.--aur-cell-padding-right]="columnConfig.size?.paddingRight"
                [ngClass]="_alignClass[columnConfig.key]">
              <ng-container *ngTemplateOutlet="headerValue"></ng-container>
            </th>
          </ng-container>

          <!-- else not sortable -->
          <ng-template #notSortable>
            <th mat-header-cell *matHeaderCellDef
                [style.width]="columnConfig.size?.width"
                [style.min-width]="columnConfig.size?.minWidth"
                [style.max-width]="columnConfig.size?.maxWidth"
                [class.aur-col-fit]="columnConfig.size?.fit"
                [style.--aur-cell-padding-left]="columnConfig.size?.paddingLeft"
                [style.--aur-cell-padding-right]="columnConfig.size?.paddingRight"
                [ngClass]="_alignClass[columnConfig.key]">
              <ng-container *ngTemplateOutlet="headerValue"></ng-container>
            </th>
          </ng-template>

          <!--      header value: кастомный шаблон (ngxAurHeaderCellDef) имеет приоритет над name/headerView-->
          <ng-template #headerValue>
            <ng-container *ngIf="headerTpl(columnConfig.key) as hTpl; else builtinHeader">
              <ng-container *ngTemplateOutlet="hTpl; context: headerCtx(columnConfig)"></ng-container>
            </ng-container>
            <ng-template #builtinHeader>
              <lib-column-view [config]="columnConfig.headerView"
                               [value]="columnConfig.name">
              </lib-column-view>
            </ng-template>
          </ng-template>

          <!-- column value получать настройки колонок нужно через getView(rowIndex, columnConfig.key) там находятся уже
          подготовленные значения для использования-->
          <td mat-cell *matCellDef="let element;"
              [style.width]="columnConfig.size?.width"
              [style.min-width]="columnConfig.size?.minWidth"
              [style.max-width]="columnConfig.size?.maxWidth"
              [class.aur-col-fit]="columnConfig.size?.fit"
              [style.--aur-cell-padding-left]="columnConfig.size?.paddingLeft"
              [style.--aur-cell-padding-right]="columnConfig.size?.paddingRight"
              [ngClass]="_alignClass[columnConfig.key]"
              [class.aur-row-link-cell]="rowLinkProvider.isNav(columnConfig.key) && rowLinkProvider.hasLink(element)">
            <!-- ссылочная строка: навигационные data-ячейки оборачиваются в <a routerLink>;
                 первая нав-ячейка — единственный tab-стоп (tabindex=0 + aria-label). -->
            <a *ngIf="rowLinkProvider.isNav(columnConfig.key) && rowLinkProvider.hasLink(element); else cellNoLink"
               class="aur-row-link"
               [routerLink]="rowLinkProvider.target(element)"
               [state]="rowLinkProvider.state(element)"
               [queryParams]="rowLinkProvider.queryParams(element)"
               [attr.tabindex]="rowLinkProvider.isPrimary(columnConfig.key) ? 0 : -1"
               [attr.aria-label]="rowLinkProvider.isPrimary(columnConfig.key) ? rowLinkProvider.ariaLabel(element) : null">
              <ng-container *ngTemplateOutlet="cellInner; context: {element: element, columnConfig: columnConfig}"></ng-container>
            </a>
            <ng-template #cellNoLink>
              <ng-container *ngTemplateOutlet="cellInner; context: {element: element, columnConfig: columnConfig}"></ng-container>
            </ng-template>

            <!-- содержимое ячейки: кастомный шаблон (ngxAurCellDef) имеет приоритет над valueView -->
            <ng-template #cellInner let-element="element" let-columnConfig="columnConfig">
              <ng-container *ngIf="_cellTemplates.get(columnConfig.key) as cellTpl; else builtinCell">
                <ng-container *ngTemplateOutlet="cellTpl; context: cellCtx(element, columnConfig.key)"></ng-container>
              </ng-container>
              <ng-template #builtinCell>
                <!-- колонки без valueView минуют компоненты ячейки: лёгкий span дешевле пары компонентов -->
                <lib-column-view *ngIf="columnConfig.valueView; else plainCell"
                                 [config]="tableView[element.rowId]?.get(columnConfig.key)"
                                 [value]="element | dataPropertyGetter: columnConfig.key">
                </lib-column-view>
                <ng-template #plainCell>
                  <span class="aur-plain-cell">{{ element | dataPropertyGetter: columnConfig.key }}</span>
                </ng-template>
              </ng-template>
            </ng-template>
          </td>

          <td mat-footer-cell *matFooterCellDef
              [style.width]="columnConfig.size?.width"
              [style.min-width]="columnConfig.size?.minWidth"
              [style.max-width]="columnConfig.size?.maxWidth"
              [class.aur-col-fit]="columnConfig.size?.fit"
              [style.--aur-cell-padding-left]="columnConfig.size?.paddingLeft"
              [style.--aur-cell-padding-right]="columnConfig.size?.paddingRight"
              [ngClass]="_alignClass[columnConfig.key]">
            {{ totalRowProvider.totals.get(columnConfig.key) ?? '' }}
          </td>

        </ng-container>

        <!--        extra header top cell (дефы регистрируем только при наличии шаблона)-->
        <ng-container *ngIf="extraHeaderTopTemplate">
          <ng-container *ngFor="let extraTopCell of _displayExtraHeaderTopCell; let index = index"
                        [matColumnDef]="extraTopCell">
            <th mat-header-cell *matHeaderCellDef>
              <ng-container
                *ngTemplateOutlet="extraHeaderTopTemplate; context: {key: extraTopCell.replace(EXTRA_HEADER_CELL_TOP_SUFFIX, ''), index: index}"></ng-container>
            </th>
          </ng-container>
        </ng-container>


        <!--        extra header bottom cell (дефы регистрируем только при наличии шаблона)-->
        <ng-container *ngIf="extraHeaderBottomTemplate">
          <ng-container *ngFor="let extraBottomCell  of _displayExtraHeaderBottomCell; let index = index"
                        [matColumnDef]="extraBottomCell">
            <th mat-header-cell *matHeaderCellDef>
              <ng-container
                *ngTemplateOutlet="extraHeaderBottomTemplate; context: {key: extraBottomCell.replace(EXTRA_HEADER_CELL_BOTTOM_SUFFIX, ''), index: index}"></ng-container>
            </th>
          </ng-container>
        </ng-container>

        <!--        extra header top row-->
        <ng-container *ngIf="extraHeaderTopTemplate">
          <tr mat-header-row *matHeaderRowDef="_displayExtraHeaderTopCell;  sticky: this.tableConfig.stickyCfg?.header"
              class="extra-header-top-row">
          </tr>
        </ng-container>

        <!--        header  row-->
        <tr mat-header-row *matHeaderRowDef="_displayColumns;  sticky: this.tableConfig.stickyCfg?.header"
            [style]="_headerStyle" [ngClass]="_headerClass">
        </tr>

        <!--        extra header bottom row -->
        <ng-container *ngIf="extraHeaderBottomTemplate">
          <tr mat-header-row
              *matHeaderRowDef="_displayExtraHeaderBottomCell;  sticky: this.tableConfig.stickyCfg?.header">
          </tr>
        </ng-container>

        <tr mat-row #rowLink class="aur-data-row"
            (dragover)="onDragOver($event)"
            (drop)="onDrop($event, row)"
            *matRowDef="let row; columns: _displayColumns;"
            (click)="handleRowClick(row)"
            (keydown)="handleRowKeydown($event, row)"
            [attr.tabindex]="rowTabindex(row)"
            [attr.aria-current]="highlighted === row.rowSrc ? 'true' : null"
            (mouseenter)="onRowEnter(row)"
            (mouseleave)="onRowLeave(row)"
            [ngClass]="rowNgClass(row)"
            [style]="rowStyle(row)">
        </tr>

        <!--expanded-row (деф регистрируем только при наличии шаблона)-->
        <ng-container *ngIf="expandedRowTemplate">
          <ng-container matColumnDef="expandedRow">
            <td mat-cell class="expanded-cell" *matCellDef="let element" [attr.colspan]="_displayColumns.length"
                style="padding-right: 0!important;">
              <div class="row-detail"
                   [@detailExpand]="isExpanded(element) ? expandedStateEnum.EXPANDED : expandedStateEnum.COLLAPSED">
                <!-- timeline continuation -->
                <div *ngIf="timelineProvider.isEnabled"
                     class="aur-timeline-continuation"
                     [style.border-left-width.px]="timelineProvider.line.width"
                     [style.border-left-color]="_timelineGaps.get(element.rowId)?.bottomColor ?? timelineProvider.line.color"
                     [style.border-left-style]="_timelineGaps.get(element.rowId)?.bottomGap ? timelineProvider.line.gapStyle : timelineProvider.line.style">
                </div>
                <!-- lazy-load of details -->
                <ng-container *ngIf="isExpanded(element)">
                  <ng-container *ngTemplateOutlet="expandedRowTemplate; context: rowCtx(element)"></ng-container>
                </ng-container>
              </div>
            </td>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="expandedRowTemplate">
          <tr mat-row class="expanded-row aur-expanded-row" *matRowDef="let row; columns: ['expandedRow']"></tr>
        </ng-container>
        <!--expanded-row-->

        <ng-container *ngIf="totalRowProvider.isEnabled">
          <tr mat-footer-row class="aur-total-row" *matFooterRowDef="_displayColumns; sticky: this.tableConfig.stickyCfg?.total"
              [style]="_totalStyle" [ngClass]="_totalClass"
              [style.display]="isTotalRowVisible() ? null : 'none'"></tr>
        </ng-container>

        <!--sub-footer-row (деф регистрируем только при наличии контента)-->
        <ng-container *ngIf="subFooterRowTemplate">
          <ng-container matColumnDef="subFooterRow">
            <td mat-footer-cell *matFooterCellDef [attr.colspan]="_displayColumns.length">
              <ng-container>
                <ng-content select="[ngxAurTableSubFooterRow]"></ng-content>
              </ng-container>
            </td>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="subFooterRowTemplate">
          <tr mat-footer-row *matFooterRowDef="['subFooterRow']; sticky: this.tableConfig.stickyCfg?.subFooter"></tr>
        </ng-container>
        <!--      sub-footer-row END-->
      </table>
    </div>
  </ng-container>

  <!-- Pagination -->
  @if (this.paginationProvider.isEnabled && !externalPaginator) {
    <mat-paginator [ngClass]="{'hidePaginator': isTableBodyHide}"
                   [pageSizeOptions]="paginationProvider.sizes"
                   [pageSize]="paginationProvider.size"
                   [style]="tableConfig?.paginationCfg?.style"
                   [length]="paginatorState?.length"
                   [pageIndex]="paginatorState?.pageIndex"
                   (page)="onPageChangeInternal($event)"
                   [showFirstLastButtons]="tableConfig.paginationCfg?.showFirstLastButtons !== false">
    </mat-paginator>
  }
</div>
